import React, { useCallback } from 'react';
import { ics } from 'calendar-link';
import { useRouter } from '@tribeplatform/react-sdk';
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown';
import { CalendarType } from './types.js';
export const CalendarItemComponent = ({ actionItem, event, }) => {
    const { Link } = useRouter();
    const handleDownloadICSFile = useCallback(() => {
        try {
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.download = event.title;
            a.href = ics(event);
            a.click();
        }
        catch (_a) {
            throw new Error('failed to download ics file.');
        }
    }, [event]);
    const Icon = actionItem.icon;
    if (actionItem.type === CalendarType.ICS) {
        return (React.createElement(Dropdown.Item, { key: actionItem.name, onClick: handleDownloadICSFile, leadingIcon: Icon }, actionItem.name));
    }
    return (React.createElement(Dropdown.Item, { key: actionItem.name, as: Link, href: actionItem.url, target: "_blank", leadingIcon: Icon }, actionItem.name));
};
//# sourceMappingURL=CalendarItemComponent.js.map